import React from "react";
import { GPUInstanceType } from "components/Environment/Settings/Tabs/Compute/InstanceChanger/GPUTypes";
import { DeployPageContent } from "../shared/DeployPageContent";
import { ProcessedLaunchableData } from "../../utils";

interface MockLaunchableDeployProps {
  mockData?: ProcessedLaunchableData;
  instanceObject: GPUInstanceType | null;
  setInstanceObject: (instanceObject: GPUInstanceType | null) => void;
  instanceStorage: string;
}

const MockLaunchableDeploy: React.FC<MockLaunchableDeployProps> = ({
  mockData,
  instanceObject,
  setInstanceObject,
  instanceStorage,
}) => {
  if (!mockData) {
    return <div>No Launchable Data</div>;
  }

  return (
    <DeployPageContent
      intendedInstanceType={mockData?.instanceType || null}
      intendedDiskStorage={mockData?.diskStorage || ""}
      loading={false}
      launchableData={mockData}
      instanceTypeObject={instanceObject}
      instanceStorage={mockData?.diskStorage || ""}
      instanceLoading={false}
      nameErrorMessage=""
      isAllowedBaseImage={true}
      deploymentStarted={false}
      isInstancesLoading={false}
      allInstancesAvailable={[
        {
          id: "mock-instance",
          name: "Mock Instance",
          status: "running",
          type: "gpu",
          price: 0.5,
        },
      ]}
      isDeploymentFinished={true}
      onDeploy={() => console.log("Mock deploy")}
      activeOrgId="mock-org"
    />
  );
};

export default MockLaunchableDeploy;
